import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/solid/image.svg'
import BaseIcon from '../../BaseIcon'

const Image = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 512 512" />
}

Image.propTypes = {
	className: PropTypes.string,
}

export default Image
